import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const createNoteAgentRecruitment = createAsyncThunk("login/createNoteAgentRecruitment", async (data, thunkAPI) => {
  try {
    const resp = await axios.post(`${process.env.REACT_APP_BASE_URL}api/recruitment/notes`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("resp", resp);
    return resp.data;
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
